/* template */
export const template: string = /*html*/ `
<div id="page-svchub" class="cover">
    <div class="cover-bar">Hardware Link</div>
    <div class="cover-body border">
        <!-- svcinfo -->
        <div id="svcinfo">
            <div class="box-tb">
                <div class="topic">HwLink</div>
                <div class="text" id="hwlink">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">AutoUp</div>
                <div class="text" id="autoup">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">CSUUID</div>
                <div class="text" id="csuuid">:</div>
            </div>
        </div>
        <hr>
        <!-- device -->
        <div id="device">
            <div class="box-tb">
                <div class="topic">หน่วยงาน</div>
                <div class="text" id="">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">กลุ่มงาน</div>
                <div class="text" id="">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">ชื่ออุปกรณ์</div>
                <div class="text" id="">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">เลขทรัพย์สิน</div>
                <div class="text" id="">:</div>
            </div>
            <button id="btn-edit" class="circle sm blue"
                shadow="true">&#xf5ae;</button>
        </div>
        <hr>
        <!-- hwinfo -->
        <div id="hwinfo">
            <div class="box-tb">
                <div class="topic">Hostname</div>
                <div class="text" id="host">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">Platform</div>
                <div class="text" id="os">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">CpuModel</div>
                <div class="text" id="cpu">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">Memory</div>
                <div class="text" id="mem">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">Uptime</div>
                <div class="text" id="uptime">:</div>
            </div>
        </div>
        <hr>
        <!-- x -->
        <div id="">
            <div class="box-tb">
                <div class="topic">SmartCard</div>
                <div class="text" id="">:</div>
            </div>
            <div class="box-tb">
                <div class="topic">Biometric</div>
                <div class="text" id="">:</div>
            </div>
        </div>
    </div>
</div>
<style>
    #page-svchub {
        margin: auto;
        max-width: 600px;
        min-width: 480px;
        line-height: 1.5;
    }
    #page-svchub .topic {
        float: left;
        width: 100px;
        font-weight: 600;
    }
    #page-svchub .text {
        float: left;
        width: calc(100% - 100px);
    }
    #page-svchub #device {
        position: relative;
    }
    #page-svchub #btn-edit {
        position: absolute;
        top: 0;
        right: 0;
    }
</style>
`;